export default __webpack_public_path__ + "static/media/circle_step.33423dfd.svg";